import * as Yup from "yup";

import { TextManager } from "Components/TextContext";
import { Validation } from "Components/TextContext/commonComponentEnums";
import { ErrorPrefix } from "Constants/constants";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { Relation } from "Store/interfaces/Owner";
import { InsuranceOwnerFormValues } from "./interfaces";

type IValidationObject = {
  insuranceHolderIsOwner: Yup.MixedSchema<BooleanFormType>;
  relation: Yup.MixedSchema<Relation | undefined>;
  age: Yup.NumberSchema;
};

export const validationObject = (): IValidationObject => {
  const { getText } = TextManager;
  const invalidAgeText = getText(Validation.AGE_INVALID, {
    variables: { min: 18, max: 99 },
  });

  return {
    insuranceHolderIsOwner: Yup.mixed<BooleanFormType>().required(
      getText(Validation.INSURANCE_HOLDER_IS_OWNER_REQUIRED),
    ),
    relation: Yup.mixed<Relation>().when("insuranceHolderIsOwner", {
      is: (insuranceHolderIsOwner: BooleanFormType | undefined) =>
        insuranceHolderIsOwner === BooleanFormType.FALSE,
      then: (schema) =>
        schema
          .notOneOf(
            [Relation.OTHER],
            ErrorPrefix.BREAKING + getText(Validation.RELATION_BREAKING_ERROR),
          )
          .required(getText(Validation.RELATION_REQUIRED)),
    }),
    age: Yup.number().when("insuranceHolderIsOwner", {
      is: (insuranceHolderIsOwner: BooleanFormType | undefined) =>
        insuranceHolderIsOwner === BooleanFormType.FALSE,
      then: (schema) =>
        schema
          .min(18, invalidAgeText)
          .max(99, invalidAgeText)
          .required(getText(Validation.AGE_REQUIRED)),
    }),
  };
};

export const validationSchema =
  (): Yup.ObjectSchema<InsuranceOwnerFormValues> => {
    return Yup.object(validationObject()).defined();
  };
